import { render, staticRenderFns } from "./ResearchIncomeUpload.vue?vue&type=template&id=37d2ad8c&scoped=true&"
import script from "./ResearchIncomeUpload.vue?vue&type=script&lang=js&"
export * from "./ResearchIncomeUpload.vue?vue&type=script&lang=js&"
import style0 from "./ResearchIncomeUpload.vue?vue&type=style&index=0&id=37d2ad8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2ad8c",
  null
  
)

export default component.exports